import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Home } from 'lucide-react';

interface NavigationBarProps {
  className?: string;
}

export function NavigationBar({ className = '' }: NavigationBarProps) {
  return (
    <div className={`absolute top-4 left-4 z-30 flex items-center gap-4 ${className}`}>
      <Button variant="outline" size="sm" asChild>
        <Link href="/rendering" className="flex items-center gap-2">
          <ArrowLeft className="h-4 w-4" />
          返回渲染技术
        </Link>
      </Button>
      <Button variant="outline" size="sm" asChild>
        <Link href="/" className="flex items-center gap-2">
          <Home className="h-4 w-4" />
          主页
        </Link>
      </Button>
    </div>
  );
}